<template>
  <div class="card">
    <div class="title-box">
      <h4 class="sub-title">{{ $t('propTrade.createAccount.subscriptionDetail.title') }}</h4>
      <p class="narrative">{{ $t('propTrade.createAccount.subscriptionDetail.desc') }}</p>
    </div>
    <div class="credit-card-box mt-3">
      <div id="main" v-show="loadTemplate"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SubscriptionCreditCard',
  props: {
    chooseAccountData: {
      type: Object,
      default: () => {}
    },
    additionalData: {
      type: String,
      default: () => ''
    }
  },
  data() {
    return {
      loadTemplate: false
    };
  },
  mounted() {
    this.loadTemplate = true;

    const data = this.additionalData;

    this.showBridgerpay(data);
  },
  methods: {
    showBridgerpay(data) {
      const dataJson = JSON.parse(data);
      let script = document.createElement('script');
      script.setAttribute('src', dataJson.url);
      script.setAttribute('data-cashier-key', dataJson.key);
      script.setAttribute('data-theme', 'dark');
      script.setAttribute('data-cashier-token', dataJson.token);
      document.getElementById('main').appendChild(script);
    }
  }
};
</script>
<style lang="scss" scoped>
.title-box {
  margin-bottom: 32px;
  .sub-title {
    color: $primary-dark-blue;
    font-weight: 700;
    line-height: 20px;
    padding-bottom: 10px;
    font-size: 16px;
  }
  .narrative {
    color: #323232;
  }
}
.credit-card-box {
  max-width: 780px;
  margin: 0 auto;
}
</style>
